import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AppTranslateModule } from '@core/app-translate.module';
import { FormErrorModule } from '@feature/forms/form-error/form-error.module';
import { FormInputMaskModule } from '@feature/forms/form-input-mask/form-input-mask.module';

import { FormInputYesNoComponent } from './form-input-yes-no.component';

export const imports: NgModule['imports'] = [
  FormErrorModule,
  FormInputMaskModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatButtonToggleModule,
  ReactiveFormsModule,
];

@NgModule({
  declarations: [FormInputYesNoComponent],
  imports: [...imports, AppTranslateModule, CommonModule],
  exports: [FormInputYesNoComponent],
})
export class FormInputYesNoModule {}
